import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { connect as formikConnect } from 'formik'

import { naturalNumbers, rationalNumbers } from 'Core/masks'
import config from 'SRC/config/config.yaml'

import {
  getCurrentSubCategory,
  getAdditionalDependencies,
  getAdditionalDependenciesVisibility,
  getSpecifications
} from 'SRC/modules/categories/selectors'

import { setAdditionalDependenciesVisibility } from 'SRC/modules/categories/actions'

import { setEquipmentVisibility } from 'SRC/modules/ads/equipment/actions'
import { getEquipmentDependencies, getEquipmentVisibility } from 'SRC/modules/ads/equipment/selectors'

import { getSpecsWithUpdatedVisibility, getConditionTrusty, getIsVisible } from 'SRC/modules/ads/shared/functions'

import { SelectDropdown, Wrapper } from 'SRC/ui/FormElementsNew'

import { TextSpecification } from '../TextSpecification'
import { SingleSelectSpecification } from '../SingleSelectSpecification'
import { MultiSelectSpecification } from '../MultiSelectSpecification'

const sortSpecifications = (fields = []) => fields.concat().sort((a, b) => a.weightAdd - b.weightAdd)

const getTextInputMask = allowedCharacters => {
	let mask = null

	if (!Array.isArray(allowedCharacters)) return null
	if (['rational', 'natural', 'numbers'].some(ac => allowedCharacters.includes(ac)) && allowedCharacters.length === 1) {
		
		if (allowedCharacters.includes('rational')) mask = rationalNumbers
		else if (allowedCharacters.includes('natural')) mask = naturalNumbers
		else mask = null
	}

	return mask
}

const getRelatedSpec = (spec, specs) => {
	if (spec.type !== 'input') return null

	const dependents = Array.isArray(spec.dependents) ? spec.dependents.filter(dep => dep.dependent) : []

	if (!dependents.length) return null

	const findSpec = Array.isArray(specs) ? specs.find(s => s.specification.id === dependents[0].dependent) : null

	if (findSpec) {
		return {
			dependentIndex: findSpec.index,
			...dependents[0]
		}
	}

	return null
}

class Container extends Component {
	componentDidMount () {
		const {
			specifications,
			formik,
			equipmentDependencies,
			equipmentVisibility,
			setEquipmentVisibility,
			additionalDependencies,
			additionalDependenciesVisibility,
			setAdditionalDependenciesVisibility
		} = this.props

		if (equipmentDependencies && equipmentDependencies.byGroup) {
      const specsIds = []
      Object.keys(equipmentDependencies.byGroup).forEach(group => {
        const visibilityCondition = equipmentDependencies.byGroup[group]

        if (visibilityCondition && visibilityCondition.hide) {
          Object.keys(visibilityCondition.hide).forEach(specId => {
            if (!specsIds.includes(specId)) specsIds.push(specId)
          })
        }

        if (visibilityCondition && visibilityCondition.show) {
          Object.keys(visibilityCondition.show).forEach(specId => {
            if (!specsIds.includes(specId)) specsIds.push(specId)
          })
        }

        const equipmentVisibilityUpdated = { ...equipmentVisibility }

        specsIds.forEach(specId => {
					const findSpecIndex = formik.values.specifications.findIndex(spec => spec.id === Number(specId))

					if (findSpecIndex !== -1) {
						const findSpec = specifications.find(spec => spec.specification.id === Number(specId))
						const specValue = formik.values.specifications[findSpecIndex].value

						if (findSpec) this.changeEquipmentGroupsVisibility(findSpec, specValue, equipmentVisibilityUpdated)
					}
        })

        setEquipmentVisibility(equipmentVisibilityUpdated)
      })
		}

		if (additionalDependencies && additionalDependencies.byType) {
      const specsIds = []
      Object.keys(additionalDependencies.byType).forEach(type => {
        const visibilityCondition = additionalDependencies.byType[type]

        if (visibilityCondition && visibilityCondition.hide) {
          Object.keys(visibilityCondition.hide).forEach(specId => {
            if (!specsIds.includes(specId)) specsIds.push(specId)
          })
        }

        if (visibilityCondition && visibilityCondition.show) {
          Object.keys(visibilityCondition.show).forEach(specId => {
            if (!specsIds.includes(specId)) specsIds.push(specId)
          })
        }

        const additionalDependenciesVisibilityUpdated = { ...additionalDependenciesVisibility }

        specsIds.forEach(specId => {
					const findSpecIndex = formik.values.specifications.findIndex(spec => spec.id === Number(specId))

					if (findSpecIndex !== -1) {
						const findSpec = specifications.find(spec => spec.specification.id === Number(specId))
						const specValue = formik.values.specifications[findSpecIndex].value

						if (findSpec) this.changeAdditionalDependentsVisibility(findSpec, specValue, additionalDependenciesVisibilityUpdated)
					}
        })

        setAdditionalDependenciesVisibility(additionalDependenciesVisibilityUpdated)
      })
    }
	}

	prepareSpecifications = () => {
		const { specifications, formik } = this.props

		const isBuyingAd = formik && formik.values.isBuying

		const preparedSpecs = []

		specifications.forEach(item => {
			const specInForm = formik.values.specifications[item.index]

			if (item.skip) return

			preparedSpecs.push({
				id: `specification-${item.specification.id}`,
				label: item.specification.title,
				index: item.index,
				name: `specifications[${item.index}].value`,
				isRequired: Boolean(item.required && !isBuyingAd),
				type: ['select', 'multiselect', 'date', 'stars'].includes(item.specification.type)
					? item.specification.type
					: 'text',
				hint: item.specification.hint,
				placeholder: item.specification.placeholder,
				measure: item.specification.measure,
				options: ['select', 'multiselect'].includes(item.specification.type)
					? item.specification.options.map(option => ({
							id: `${item.specification.id}-${option}`,
							label: option,
							value: `${option}`
						}))
					: null,
				allowedCharacters: item.specification.allowedCharacters,
				relatedSpec: getRelatedSpec(item.specification, specifications),
				mask: getTextInputMask(item.specification.allowedCharacters),
				specification: item.specification,
				isHidden: specInForm ? specInForm.isHidden : true
			})
		})

		return preparedSpecs
	}

	updateRelatedSpecsVisibility = async (spec, value) => {
		const { specifications, formik, formType } = this.props

		const currentSpecificationValues = [...formik.values.specifications]

		const updatedSpecificationValues = getSpecsWithUpdatedVisibility({
			categorySpecifications: specifications,
			categorySpecification: spec,
			initialSpecificationValues: currentSpecificationValues,
			specificationValue: value,
			formType
		})

		await formik.setFieldValue('specifications', updatedSpecificationValues)
	}

	changeEquipmentGroupsVisibility = (spec, value, equipmentVisibilityUpdated) => {
    const { formik, equipmentDependencies } = this.props

		const specification = spec && spec.specification

    if (specification && equipmentDependencies && equipmentDependencies.bySpec && Array.isArray(equipmentDependencies.bySpec[specification.id])) {
      equipmentDependencies.bySpec[specification.id].forEach(dependency => {
        const groupVisibilityCondition = equipmentDependencies.byGroup[dependency.grupa]

        const groupVisibilityConditionValues = {
          hide: groupVisibilityCondition.hide
            ? Object.keys(groupVisibilityCondition.hide).reduce((acc, curr) => {
              let specValue

              if (Number(curr) === specification.id) {
                specValue = value
              } else {
								const specIndex = formik.values.specifications.findIndex(spec => spec.id === Number(curr))

                if (specIndex !== -1) {
                  specValue = formik.values.specifications[specIndex].value
                }
              }

              const isConditionTrusty = getConditionTrusty(specValue, groupVisibilityCondition.hide[curr])
              acc[curr] = isConditionTrusty

              return acc
            }, {})
            : null,
          show: groupVisibilityCondition.show
            ? Object.keys(groupVisibilityCondition.show).reduce((acc, curr) => {
              let specValue

              if (Number(curr) === specification.id) {
                specValue = value
              } else {
								const specIndex = formik.values.specifications.findIndex(spec => spec.id === Number(curr))

                if (specIndex !== -1) {
                  specValue = formik.values.specifications[specIndex].value
                }
              }

              const isConditionTrusty = getConditionTrusty(specValue, groupVisibilityCondition.show[curr])
              acc[curr] = isConditionTrusty

              return acc
            }, {})
            : null
				}

        const isGroupVisible = getIsVisible(groupVisibilityConditionValues)

        if (isGroupVisible !== equipmentVisibilityUpdated[dependency.grupa]) {
          equipmentVisibilityUpdated[dependency.grupa] = isGroupVisible

          if (!isGroupVisible) {
						const findGroup = config.adForm.equipmentGroups.find(group => group.code === dependency.grupa)

						if (findGroup) {
							formik.setFieldValue('equipment', {
								...formik.values.equipment,
								[findGroup.id]: []
							})
						}
          }
        }
      })
    }
	}

	changeAdditionalDependentsVisibility = (spec, value, additionalDependenciesVisibilityUpdated) => {
		const { additionalDependencies, formik } = this.props

		const specification = spec && spec.specification

    if (specification && additionalDependencies && additionalDependencies.bySpec && Array.isArray(additionalDependencies.bySpec[specification.id])) {
      additionalDependencies.bySpec[specification.id].forEach(dependency => {

        const visibilityCondition = additionalDependencies.byType[dependency.type]

        const visibilityConditionValues = {
          hide: visibilityCondition.hide
            ? Object.keys(visibilityCondition.hide).reduce((acc, curr) => {
              let specValue

              if (Number(curr) === specification.id) {
                specValue = value
              } else {
								const specIndex = formik.values.specifications.findIndex(spec => spec.id === Number(curr))

                if (specIndex !== -1) {
                  specValue = formik.values.specifications[specIndex].value
                }
              }

              const isConditionTrusty = getConditionTrusty(specValue, visibilityCondition.hide[curr])
              acc[curr] = isConditionTrusty

              return acc
            }, {})
            : null,
          show: visibilityCondition.show
            ? Object.keys(visibilityCondition.show).reduce((acc, curr) => {
              let specValue

              if (Number(curr) === specification.id) {
                specValue = value
              } else {
								const specIndex = formik.values.specifications.findIndex(spec => spec.id === Number(curr))

                if (specIndex !== -1) {
                  specValue = formik.values.specifications[specIndex].value
                }
              }

              const isConditionTrusty = getConditionTrusty(specValue, visibilityCondition.show[curr])
              acc[curr] = isConditionTrusty

              return acc
            }, {})
            : null
        }

        const isVisible = getIsVisible(visibilityConditionValues)

        if (isVisible !== additionalDependenciesVisibilityUpdated[dependency.type]) {
          additionalDependenciesVisibilityUpdated[dependency.type] = isVisible

          switch (dependency.type) {
            case 'swapp':
              // remove swapp if !isVisible
              if (!isVisible) {
								formik.setFieldValue('swapp', 'No')
								formik.setFieldValue('swapps', -1)
              }
              break
            case 'price':
              if (!isVisible) {
								formik.setFieldValue('price', -1)
								formik.setFieldValue('discountedPrice', -1)
								formik.setFieldValue('priceFrom', -1)
								formik.setFieldValue('priceTo', -1)
              }
              break
            case 'price_period':
              if (!isVisible) {
								formik.setFieldValue('priceDaily', -1)
								formik.setFieldValue('priceMonthly', -1)
              }
              break
            default: break
          }
        }
      })
    }
  }

	render() {
		const preparedSpecifications = this.prepareSpecifications()
		const nonStarsSpecs = preparedSpecifications.filter(spec => spec.type !== 'stars')

		const starsSpecs = preparedSpecifications.filter(spec => spec.type === 'stars')
		const starsSpecsLength = Array.isArray(starsSpecs) ? starsSpecs.length : 0

		return (
			<React.Fragment>
				{nonStarsSpecs.map(specification => {
					if (!specification.isHidden) {
						const specProps = {
							spec: specification
						}

						switch(specification.type) {
							case 'text': {
								return <TextSpecification key={specification.id} {...specProps} />
							}
							case 'select': {
								specProps.updateRelatedSpecsVisibility = this.updateRelatedSpecsVisibility
								specProps.changeEquipmentGroupsVisibility = this.changeEquipmentGroupsVisibility
								specProps.changeAdditionalDependentsVisibility = this.changeAdditionalDependentsVisibility

								return <SingleSelectSpecification key={specification.id} {...specProps} />
							}
							case 'multiselect': {
								specProps.updateRelatedSpecsVisibility = this.updateRelatedSpecsVisibility
								specProps.changeEquipmentGroupsVisibility = this.changeEquipmentGroupsVisibility
								specProps.changeAdditionalDependentsVisibility = this.changeAdditionalDependentsVisibility

								return <MultiSelectSpecification key={specification.id} {...specProps} />
							}
							// case: 'date'
							default: return null
						}
					}
					return null
				})}

				{/* STAR */}
				{/* {starsSpecsLength ? (
					<FormSection title="OCIJENITE VOZILO">
						{starsSpecs.map(specification => this.renderStarsSpec(specification))}
					</FormSection>
				) : null} */}
			</React.Fragment>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const specifications = getSpecifications(state)

	const { hideSpecs, showOnlySpecs } = ownProps

  let categorySpecifications = Array.isArray(specifications) ? [...specifications] : []

  if (Array.isArray(showOnlySpecs) && showOnlySpecs.length) {
		categorySpecifications = categorySpecifications.map(item => {
			if (showOnlySpecs.includes(item.specification.title)) return item

			return {
				...item,
				skip: true
			}
		})
	}

	if (Array.isArray(hideSpecs) && hideSpecs.length) {
		categorySpecifications = categorySpecifications.map(item => {
			if (!hideSpecs.includes(item.specification.title)) return item

			return {
				...item,
				skip: true
			}
		})
	}

	const specs = categorySpecifications.map((item, index) => ({
    ...item,
    index
  }))

	return {
		currentSubCategory: getCurrentSubCategory(state),
		specifications: sortSpecifications(specs),
		equipmentDependencies: getEquipmentDependencies(state),
		equipmentVisibility: getEquipmentVisibility(state),
    additionalDependenciesVisibility: getAdditionalDependenciesVisibility(state),
    additionalDependencies: getAdditionalDependencies(state)
	}
}

const enhance = compose(
	connect(mapStateToProps, { setEquipmentVisibility, setAdditionalDependenciesVisibility }),
	formikConnect
)

Container.displayName = 'SpecificationContainer'

export default enhance(Container)
